<a type="button"
   [routerLink]="basketUrl"
   [attr.aria-label]="'MENU.BASKET'|translate"
   [attr.quantity]="basketQuantity$ | async">
    <app-svg use="basket"></app-svg>
</a>
